import React, { useEffect, useState, useRef } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Header } from "../../components/header/Header";
import uploadIcon from "../../assets/upload_img.svg";
import textImage from "../../assets/test.jpg";
import { useDispatch, useSelector } from "react-redux";
import { createSelector } from "@reduxjs/toolkit";
import { getAllCategoriesThunk as onGetAllCategoriesThunk } from "../../slices/category/thunk";
import { userContestThunk as onUserContestThunk } from "../../slices/contest/thunk";
import { getEventDetailsThunk, getInhouseArtistsThunk } from "../../slices/events/thunk"
import { Spinner } from "../../components/spinner/Spinner";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { getAuthUser } from "../../utils/GetAuthUser";
import { toast } from "react-hot-toast";
import axios from "axios";
import { RiCheckboxCircleLine, RiCloseCircleLine } from "react-icons/ri";
import * as faceapi from "face-api.js";
import Select from "react-select";
import ArtistSelect from "../users/dropdown";


// ✅ Stripe imports
import {
  useStripe,
  useElements,
  CardNumberElement,
  CardExpiryElement,
  CardCvcElement,
} from "@stripe/react-stripe-js";

const ReferrelUser = () => {

  const [images, setImages] = useState([]);
  const [categories, setCategories] = useState([]);
  const [artists, setArtists] = useState([]);
  const [isShowLoader, setIsShowLoader] = useState(false);
  const [isPaying, setIsPaying] = useState(false);
  const [isRedirectAllow, setIsRedirectAllow] = useState(false);

  const [discount, setDiscount] = useState(0);
  const [eventDetail, setEventDetail] = useState(null);
  const [contestId, setContestId] = useState(null);

  const perPersonCharges = 25;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const authUser = getAuthUser();

  const stripe = useStripe();
  const elements = useElements();

  // Redux selectors
  const selectCategoryState = (state) => state.category;
  const selectContestState = (state) => state.contest;

  const categoriesSelector = createSelector(
    selectCategoryState,
    (category) => ({
      categoriesList: category.categoriesList,
    })
  );

  const contestSelector = createSelector(selectContestState, (contest) => ({
    isLoading: contest.isLoading,
    isSuccess: contest.isSuccess,
    newContest: contest.newContest,
  }));

  const { categoriesList } = useSelector(categoriesSelector);
  const { isLoading, isSuccess, newContest } = useSelector(contestSelector);





  useEffect(() => {
    dispatch(onGetAllCategoriesThunk());
  }, [dispatch]);

  useEffect(() => {
    setCategories(categoriesList);
  }, [categoriesList]);

  useEffect(() => {
    setIsShowLoader(isLoading);
  }, [isLoading]);

  useEffect(() => {
    if (isSuccess && newContest) {
      setIsRedirectAllow(true);
    }
  }, [isSuccess, newContest]);

  //isRedirectAllow
  useEffect(() => {
    if (isRedirectAllow) {

  //     if(eventDetail == null){
  //  toast.success("Contest created successfully!");
  //     navigate("/user/my-contests");
   
  //     }else{
   toast.success("Contest created successfully! Now, please select an artist.");
  //  console.log("Event Detail for navigation:", contestId);
      navigate(`/user/contest-artist-event-request/${contestId}`);
   
      // }
    }
    setIsRedirectAllow(false);
  }, [isRedirectAllow, navigate]);

 const validationSchema = Yup.object({
  categoryId: Yup.string().required("Please select a category"),
  people: Yup.number()
    .typeError("Must be a number")
    .positive("Enter a valid number")
    .required("Required"),
  idea: Yup.string()
    .min(5, "Idea must be at least 5 characters")
    .required("Please enter your idea"),
  images: Yup.array()
    .min(1, "Please upload at least one image")
    .max(2, "You can upload up to 2 images only")
    .test('fileSize', 'Each image must be less than 5MB', function(value) {
      if (!value || value.length === 0) return true;
      
      for (let file of value) {
        if (file && file.size > 5 * 1024 * 1024) {
          return this.createError({
            message: `Image size must not exceed 5MB`,
          });
        }
      }
      return true;
    }),
});

  // ✅ Formik setup
  const formik = useFormik({
    initialValues: {
      categoryId: "",
      people: 1,
      idea: "",
      images: [],
    },
    validationSchema,
    onSubmit: async (values) => {


    //  console.log('1');
      const totalAmount = perPersonCharges * Number(values.people || 0); // amount before discount
      const toPayAmount = perPersonCharges * (Number(formik.values.people) || 0) * ((100 - discount) * 0.01); // amount after discount
      const discountAmount = totalAmount - toPayAmount; // amount of discount

    //  console.log('11');

      if (toPayAmount <= 0) {
        toast.error("Please enter valid number of people.");
        return;
      }
    //  console.log('1s');

      if (!stripe || !elements) {
        toast.error("Stripe not initialized");
        return;
      }
     

      const cardElement = elements.getElement(CardNumberElement);
      setIsPaying(true);

      const { paymentMethod, error } = await stripe.createPaymentMethod({
        type: "card",
        card: cardElement,
        billing_details: { name: authUser?.user?.name || "Referral User" },
      });
    


      if (error) {
        toast.error(error.message);
        setIsPaying(false);
        return;
      }

//   console.log(process.env.REACT_APP_API_URL);
// console.log({
//           amount: toPayAmount * 100,
//           user_id: authUser?.user?.id,
//           plan_id: null,
//           payment_method: paymentMethod.id,
//         });


      // const res = null;

      // try{
const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/create-stripe-payment-intent`,
        {
          amount: toPayAmount * 100,
          user_id: authUser?.user?.id,
          plan_id: null,
          payment_method: paymentMethod.id,
        }
      );
      // }catch(e){
      //   toast.error( "Payment failed, try again later");
      //   setIsPaying(false);
      //   return;
      // }
      
      
    //   console.log("res");
    //   console.log(res);
    //  console.log('ssss1');


      const clientSecret = res.data.data;

      const { paymentIntent, error: confirmError } =
        await stripe.confirmCardPayment(clientSecret, {
          payment_method: paymentMethod.id,
        });

    //  console.log('asdasd1');


      if (confirmError) {
        toast.error(confirmError.message);
        setIsPaying(false);
        return;
      }

    //  console.log('sadasdsad1');


      if (paymentIntent.status === "succeeded") {
        const formData = new FormData();
        formData.append("userId", authUser?.user?.id);
        formData.append("description", values.idea);
        // formData.append("is_publish", 1);
        formData.append("is_publish", 2);
        formData.append("is_reffrel_user", 1);
        formData.append("is_referral_contest", 1);
        formData.append("category[]", values.categoryId);
        formData.append("total_amount", toPayAmount);
        formData.append("stripe_payment_id", paymentIntent.id);
        if (eventDetail !== null) {
formData.append("is_publish", 2);
          formData.append("event_id", eventDetail.id ?? null);
          formData.append("discount", discountAmount ?? 0);
          formData.append("actual_amount", totalAmount);     // amount before discount

          // formData.append("artist_id", formik.values.artist ?? null);

        }



        for (let pair of formData.entries()) {
          // console.log(`${pair[0]}: ${pair[1]}`);

        }


        values.images.forEach((file) => formData.append("media[]", file));
        dispatch(onUserContestThunk(formData)).unwrap()
          .then((res) => {
           setContestId(res);
          })
        setIsPaying(false);
      }
    },
  });

  const totalCost = perPersonCharges * (Number(formik.values.people) || 0) * ((100 - discount) * 0.01);

  const handleCheckboxChange = (categoryId) => {
    formik.setFieldValue("categoryId", categoryId);
  };

  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);
    const total = [...images, ...files].slice(0, 2);
    setImages(total);
    formik.setFieldValue("images", total);
    e.target.value = "";
    //here we need to find out total number of faces
    detectFaces(total);

  };



  const removeImage = (idx) => {
    const updated = images.filter((_, i) => i !== idx);
    setImages(updated);
    formik.setFieldValue("images", updated);
    detectFaces(updated);

  };


  const location = useLocation();
  const params = useParams();

  // Fetch event details when URL param changes
  useEffect(() => {
    if (location.pathname.includes("connected-event") && params.eventId) {

      fetchEventDetails(params.eventId);
      // fetchArtistList();
    } else {
      // console.log("its a simple contest");
    }
  }, [location.pathname, params.eventId]); // ✅ only depend on the URL param




  // Function to fetch event details using your Redux thunk
  const fetchEventDetails = async (encryptedId) => {
    try {
      const result = await dispatch(getEventDetailsThunk({ id: encryptedId })).unwrap();
      const eventData = result.data[0];
      setEventDetail(eventData); // ✅ update state
      setDiscount(eventData.discount);
    } catch (error) {
      toast.error(error?.message || "Failed to load event details");
    }
  };

//   //fetch artist list inhouse
//   const fetchArtistList = async () => {
//     try {
//       const res = await dispatch(getInhouseArtistsThunk()).unwrap();
//       // console.log("In-house artists:", res.data);
//       //now we need to set artists in dropdown
//       setArtists(res.data);
//       //we need to find for which artist we have refferal code in our local storage and then we need to set that artist as selected in dropdown
// // console.log(res.data);
//       try {

//         var user = localStorage.getItem("authUser");
//         var userdata = JSON.parse(user);
//         var referralCode = userdata?.user.referral_code;
//         // console.log("Referral Code from localStorage:", referralCode);
//         if (referralCode) {
//           const referredArtist = res.data.find(artist => artist.referralCode === referralCode && artist.available);
//           if (referredArtist) {
//             formik.setFieldValue("artist", referredArtist.id);
//           } else {
//             // console.log("No artist found for referral code:", referralCode);
//           }
//         }
//       } catch (e) { }


//     }catch (e) { };
// }

//face detection thing


const imgRef = useRef();
const canvasRef = useRef();
const [loading, setLoading] = useState(true);

useEffect(() => {
  const loadModels = async () => {
    const MODEL_URL = "https://justadudewhohacks.github.io/face-api.js/models";
    await faceapi.nets.tinyFaceDetector.loadFromUri(MODEL_URL);
    setLoading(false);
  };

  loadModels();
}, []);

const fileToImage = (file) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.src = URL.createObjectURL(file);
    img.onload = () => resolve(img);
    img.onerror = reject;
  });
};

const detectFaces = async (imglist) => {




  if (imglist) {

    var faces = 0;
    for (let i = 0; i < imglist.length; i++) {
      try {
        const img = await fileToImage(imglist[i]);
        const detections = await faceapi.detectAllFaces(
          img,
          new faceapi.TinyFaceDetectorOptions()
        );

        faces += detections.length;
      } catch (e) { }



    }

    //now we need to set variable 
    faces = faces === 0 ? 1 : faces; // if no face detected, consider it as 1 person
    formik.setFieldValue("people", faces);


  }







};


return (
  <>
    {/* Header */}
    <header className="fixed top-0 left-0 md:left-[205px] md:w-[calc(100%-205px)] z-40 bg-white w-full h-14 md:h-[84px] flex items-center justify-center px-4 sm:px-[51px] border-b border-border_color">
      <Header name={authUser?.user?.name} />
    </header>

    {/* Main */}
    <div className="w-full max-w-full mx-auto bg-[#F7F7F7] pt-4 pb-10">
      <div className="w-full flex items-center justify-center">
        <h1 className="text-black text-xl sm:text-3xl font-bold font-grotesk">
          Transform <span className="text-primary">Idea to Visual</span>
        </h1>

      </div>

      


     <div className="w-full mt-5 border border-border_color px-2 sm:px-7 py-5 rounded-[20px]">
  <form onSubmit={formik.handleSubmit} className="w-full">

    {/* 🎨 Categories */}
    <div className="w-full">
      <div className="flex gap-2 flex-wrap">
        {categories.map((option) => (
          <label
            key={option.id}
            onClick={() => handleCheckboxChange(option.id.toString())}
            className={`flex items-center justify-center border py-[8px] px-[18px] rounded-3xl font-bold text-[11px] font-grotesk text-[#262626] cursor-pointer transition ${
              formik.values.categoryId === option.id.toString()
                ? "border-primary text-primary"
                : "border-[#DDDDDD] hover:border-secondary hover:text-secondary"
            }`}
          >
            {option.title}
          </label>
        ))}
      </div>
      {formik.touched.categoryId && formik.errors.categoryId && (
        <p className="text-red-500 text-xs mt-1">{formik.errors.categoryId}</p>
      )}
    </div>

    {/* 📸 Upload + 💰 People + Summary */}
    <div className="flex gap-5 sm:gap-3 mt-6 flex-col lg:flex-row">

      {/* Left: Upload + Idea */}
      <div className="w-full lg:w-1/2 flex flex-col gap-4">
        <div className="flex flex-col items-center justify-center w-full min-h-[237px] bg-white border-2 border-dashed border-border_color rounded-xl relative p-4">
          {images.length > 0 && (
            <div
              className={`flex gap-3 flex-wrap justify-center items-center ${
                images.length === 1 ? "mb-3" : "mb-2"
              }`}
            >
              {images.map((img, idx) => (
                <div
                  key={idx}
                  className="relative w-[100px] h-[100px] border rounded-lg overflow-hidden"
                >
                  <img
                    src={URL.createObjectURL(img)}
                    alt="preview"
                    className="object-cover w-full h-full"
                  />
                  <button
                    type="button"
                    onClick={() => removeImage(idx)}
                    className="absolute top-0 right-0 bg-red-500 text-white rounded-full w-5 h-5 flex items-center justify-center text-xs"
                  >
                    ✕
                  </button>
                </div>
              ))}
            </div>
          )}

          {images.length < 2 && (
            <>
              <label
                htmlFor="file-upload"
                className="cursor-pointer text-gray-500 hover:text-secondary flex items-center gap-1 mt-2"
              >
                <img src={uploadIcon} alt="upload" />
                <span className="text-black text-xs sm:text-[16px] font-medium font-grotesk">
                  Upload your image (Max 2)
                </span>
              </label>
              <input
                id="file-upload"
                type="file"
                accept="image/*"
                multiple
                className="hidden"
                onChange={handleImageChange}
              />
            </>
          )}
        </div>

        {formik.touched.images && formik.errors.images && (
          <p className="text-red-500 text-xs mt-1">{formik.errors.images}</p>
        )}

        {/* 💡 Idea (below image upload) */}
        <div>
          <label
            htmlFor="idea"
            className="block text-lable_color font-grotesk text-[16px] font-bold mb-1"
          >
            Add some ideas
          </label>
          <textarea
            id="idea"
            name="idea"
            rows={4}
            placeholder="Type your idea"
            className="w-full resize-none p-3 rounded-xl border border-border_color text-[#201D1D] text-[16px] font-medium font-grotesk focus:outline-none focus:ring-1 focus:ring-primary focus:border-primary"
            value={formik.values.idea}
            onChange={formik.handleChange}
          />
          {formik.touched.idea && formik.errors.idea && (
            <p className="text-red-500 text-xs mt-1">{formik.errors.idea}</p>
          )}
        </div>
      </div>

      {/* Right: People Input + Summary + Payment Details */}
      <div className="w-full lg:w-1/2 flex flex-col gap-4">

        {/* 💰 People Input */}
        <div>
          <label className="block text-lable_color font-grotesk text-[16px] font-bold mb-1">
            How Many People
          </label>
          <input
            id="people"
            name="people"
            type="number"
            min={1}
            placeholder="Enter number of people"
            className="w-full px-3 py-[14px] bg-white border text-[#201D1D] text-[16px] font-medium font-grotesk border-border_color rounded-xl outline-none focus:ring-1 focus:ring-primary focus:border-primary"
            value={formik.values.people}
            onChange={formik.handleChange}
          />
          <p className="text-gray-800 font-medium text-sm mt-2">
            Per Person:{" "}
            <span className="text-primary font-bold">${perPersonCharges}</span>{" "}
            {discount !== 0 && (
              <span>
                | Discount:{" "}
                <span className="text-primary font-bold">{discount}%</span>{" "}
              </span>
            )}
            | Total:{" "}
            <span className="text-primary font-bold">${totalCost}</span>
          </p>
          {eventDetail !== null && (
            <p className="text-gray-800 font-medium text-sm mt-0">
              Enjoy{" "}
              <span className="text-primary font-bold">{discount}%</span>{" "}
              discount on{" "}
              <span className="text-primary font-bold">{eventDetail.title}</span>
            </p>
          )}
        </div>

        {/* 📋 Summary (below People input, visible when people > 0) */}
        {formik.values.people && Number(formik.values.people) > 0 && (
          <div className="w-full bg-white border border-border_color rounded-2xl shadow-sm p-5">
            <h3 className="text-lg font-bold text-secondary mb-3">Summary</h3>
            <div className="mb-4">
              <div className="flex items-baseline gap-2">
                <span className="text-3xl font-bold text-primary">
                  ${totalCost.toFixed(2)}
                </span>
                <span className="text-sm text-gray-600">total</span>
              </div>
              <p className="text-sm text-gray-700">Referral Artwork</p>
            </div>

            <ul className="space-y-2 text-sm">
              <li className="flex items-center gap-2">
                <RiCheckboxCircleLine className="text-green-500" />
                <span>
                  Category:{" "}
                  {categories.find(
                    (c) => c.id.toString() === formik.values.categoryId
                  )?.title || "N/A"}
                </span>
              </li>
              <li className="flex items-center gap-2">
                {formik.values.people && Number(formik.values.people) > 0 ? (
                  <RiCheckboxCircleLine className="text-green-500" />
                ) : (
                  <RiCloseCircleLine className="text-red-500" />
                )}
                <span>People: {formik.values.people}</span>
              </li>
              <li className="flex items-center gap-2">
                <RiCheckboxCircleLine className="text-green-500" />
                <span>Per Person: ${perPersonCharges}</span>
              </li>
              <li className="flex items-center gap-2">
                <RiCheckboxCircleLine className="text-green-500" />
                <span>Total Amount: ${totalCost.toFixed(2)}</span>
              </li>
            </ul>

            <div className="mt-6 border-t border-border_color pt-4">
              <div className="grid grid-cols-2 gap-2 text-sm mb-3">
                <span className="text-gray-700">Plan Name</span>
                <span className="text-right text-secondary">Referral Artwork</span>
                <span className="text-gray-700">Price</span>
                <span className="text-right text-secondary">
                  ${perPersonCharges} per person
                </span>
                {discount !== 0 && (
                  <>
                    <span className="text-gray-700">Discount</span>
                    <span className="text-right text-secondary">{discount}%</span>
                  </>
                )}
                <span className="text-gray-700">Total</span>
                <span className="text-right text-secondary">
                  ${totalCost.toFixed(2)}
                </span>
              </div>
            </div>
          </div>
        )}

        {/* 💳 Payment Details (below Summary, visible when people > 0) */}
        {formik.values.people && Number(formik.values.people) > 0 && (
          <div className="w-full bg-white border border-border_color rounded-2xl shadow-sm p-5">
            <h3 className="text-lg font-bold mb-3 text-secondary">
              Payment Details
            </h3>
            <div className="mb-3">
              <CardNumberElement className="p-3 border rounded-xl" />
            </div>
            <div className="flex flex-col md:flex-row gap-2 mb-4">
              <CardExpiryElement className="p-3 border rounded-xl w-full" />
              <CardCvcElement className="p-3 border rounded-xl w-full" />
            </div>
          </div>
        )}

      </div>
    </div>

    {/* Submit */}
    <div className="w-full flex items-center justify-end mt-6">
      <button
        type="submit"
        className="px-8 py-3 bg-primary text-sm text-white rounded-xl font-medium font-grotesk tracking-wide"
        disabled={isShowLoader || isPaying}
      >
        {isPaying || isShowLoader ? <Spinner /> : "Pay & Submit"}
      </button>
    </div>

  </form>
</div>
    </div>








    {/* <div>
      {loading && <p>Loading models...</p>}

      {!loading && <img
        ref={imgRef}
        src={textImage}
        alt=""
        onLoad={detectFaces}
        width="400"
      />}

      <canvas
        ref={canvasRef}
        style={{ position: "absolute", top: 0, left: 0 }}
      />
    </div> */}




  </>






);
};

export default ReferrelUser;
